import { c as _c } from "react/compiler-runtime";
import { formatTime } from "@/lib/format-data";

/**
 * "9:00 - 9:30" on a calendar card, kept on one line so larger text sizes
 * wrap before the range or after it, never through it.
 */
export function CalendarTimeRange(t0) {
  const $ = _c(9);
  const {
    start,
    end,
    timeZone
  } = t0;
  let t1;
  if ($[0] !== start || $[1] !== timeZone) {
    t1 = formatTime(start, false, timeZone);
    $[0] = start;
    $[1] = timeZone;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== end || $[4] !== timeZone) {
    t2 = formatTime(end, false, timeZone);
    $[3] = end;
    $[4] = timeZone;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <span className="whitespace-nowrap">{t1} - {t2}</span>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}